<div class="ene-button-base" matRipple [matRippleDisabled]="disabled">
  <span class="ene-button-content"><ng-content></ng-content></span>
  <mat-icon *ngIf="icon" [fontIcon]="icon"></mat-icon>
</div>
